// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"7e053e3d","898":"f42441eb"}[chunkId] + ".chunk.css";
};